import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useLocation } from "@/context/LocationContext";
import MasterProductCard from "@/components/MasterProductCard";
import { SectionHeader } from "@/components/HomeSections";

export default function CatalogCategoryRows() {
  const nav = useNavigate();
  const { location } = useLocation();
  const params = { lat: location?.lat, lng: location?.lng, per: 8 };
  const { data: rows } = useQuery({ queryKey: ["catalog-home", params], queryFn: () => api.get("/catalog/home", { params }).then((r) => r.data) });
  if (!rows?.length) return null;
  return (
    <div data-testid="catalog-category-rows">
      {rows.map((row) => (
        <section key={row.category.slug} className="mb-12" data-testid={`catalog-row-${row.category.slug}`}>
          <SectionHeader title={row.category.name} subtitle={`${row.total.toLocaleString("en-IN")} products in the Grofkart catalog`} onSeeAll={() => nav(`/category/${row.category.slug}`)} />
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-8">
            {row.products.map((p) => <MasterProductCard key={p.id} item={p} />)}
          </div>
        </section>
      ))}
    </div>
  );
}
